import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';

// The member's own "disable previews of my messages" setting. Absent until they first choose, which means off.
export function previewsDisabledFor(family: IFamilyMember[], accountId: number): boolean {
  return family.some((member) => member.id === accountId && member.disablePreviews === true);
}

// The chat list stops showing message text for everyone in the group as soon as any parent
// (the signed-in one included) has turned previews off. Other roles only affect their own pushes.
export function chatListPreviewsHidden(family: IFamilyMember[]): boolean {
  return family.some((member) => member.role === FamilyMemberType.PARENT && member.disablePreviews === true);
}



// WEBPACK FOOTER //
// ./src/services/chat/chatPreview.ts